var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseX = function SvgCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#008844"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1514 11.1516L36.8484 12.8486L25.697 24L36.8484 35.1514L35.1514 36.8485L24 25.6971L23.9999 25.6971L23.9998 25.6971L12.8484 36.8485L11.1514 35.1514L22.3028 24L11.1514 12.8486L12.8484 11.1516L23.9998 22.3029L23.9999 22.3029L24 22.303L35.1514 11.1516Z",
    fill: "#C7F700"
  })));
};
export default SvgCloseX;